import { useParams } from "react-router-dom";
import { useStudentDetailsQuery } from "../../../../../hooks/useStudentDetailsQuery";
import { StudentDetailsContent } from "../components/StudentDetailsContent";


export function StudentDetailsAboutContainer() {
    const { id } = useParams();
    const { data } = useStudentDetailsQuery(parseInt(id), true);

    return (
        <StudentDetailsContent {...data} />
    );
}
